// Packages
import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { HomepageSkeleton } from 'components/SharedComponents/loading-state/homepage-skeleton';

export class ContentContainer extends React.Component {
    constructor(props) {
        super(props);
    }

    showLoadMoreDiv() {
        const {t} = this.props;
        return (
            <div
              className={`content-card-container__load-more animated ${this.props.showLoadMore ? 'fadeIn' : 'fadeOut'}`}
              onClick={this.props.loadMoreClicked}
            >
              {t('button.load-more')}
            </div>
        );
    }

    showisLoadingDiv() {
        return (
            <div className="content-card-container__loading disabled">
                <div className="content-card-container__loading-bounce1"></div>
                <div className="content-card-container__loading-bounce2"></div>
                <div className="content-card-container__loading-bounce3"></div>
            </div>
        );
    }

    render() {
        return (
            <div>
                <div className="content-card-container">
                    {this.props.contents}
                    {this.props.isLoading && <HomepageSkeleton onlyContentPlaceholders={true} />}
                </div>
                {this.props.showLoadMore && !this.props.isLoading && this.showLoadMoreDiv()}
                {this.props.isLoading && this.showisLoadingDiv()}
            </div>
        );
    }
}

ContentContainer.propTypes = {
    t: PropTypes.func,
    contents: PropTypes.array,
    loadMoreClicked: PropTypes.func,
    isLoading: PropTypes.bool,
    showLoadMore: PropTypes.bool
};

export default (translate(['translation'])(ContentContainer));



// WEBPACK FOOTER //
// ./src/components/SharedComponents/content/content-container.js